!function ($) {

    jQuery(document).ready(function ($) {
        mobilePlacement();

        //Main nav
        $(".menu").click(function () {
            $("body").toggleClass("mobile_nav");
            $(".nav_dropdown").removeClass("d-block");
        });

        $("a.nav_dropdown_parent").click(function (e) {
            e.preventDefault();
            $(".nav_dropdown").removeClass("d-block");
            $(this).next(".nav_dropdown").toggleClass("d-block");
        });

        $("a.subnav_dropdown_parent").click(function (e) {
            e.preventDefault();
            $(".flyout_dropdown").removeClass("d-block");
            $(this).next(".flyout_dropdown").toggleClass("d-block");
        });

        $(".nav_dropdown .portal_link a").click(function (e) {
            e.preventDefault();
            $(this).parents(".nav_dropdown").removeClass("d-block");
        });

        $(".nav_dropdown .portal_link_flyout a").click(function (e) {
            e.preventDefault();
            $(this).parents(".flyout_dropdown").removeClass("d-block");
        });

        $(window).scroll(function () {
            var scroll = $(window).scrollTop();

            if (scroll >= 35) {
                $("nav").addClass("shadow");
            } else {
                $("nav").removeClass("shadow");
            }
        });

        //Search (main nav)
        function showSearch() {
            $('.search').click(function (e) {
                e.preventDefault();
                $('.search_container').toggleClass('show_search');
                $('.nav_section').toggleClass('show_search');
                $("#search-input").focus();
            });
            $('.search-close').click(function () {
                $('.search_container').removeClass('show_search');
                $('.nav_section').removeClass('show_search');
            });
        }

        $("#search-input").focus(function () {
            $(this).parent().addClass('is_focused');
        });

        $("#search-input").blur(function () {
            tmpval = $(this).val();
            if (tmpval === '') {
                $(this).parent().removeClass('is_focused');
            }
        });
        showSearch();

        //Search (search page)
        $("#search_input").focus(function () {
            $(this).parent().addClass('is_focused');
        });
        $("#search_input").blur(function () {
            tmpval = $(this).val();
            if (tmpval === '') {
                $(this).parent().removeClass('is_focused');
            }
        });

        // Bootstrap Tabs
        $('#tabs_content .tabs_container a').on('click', function (e) {
            e.preventDefault();
            $(this).tab('show');
        });
        $('#tabs_video .tabs_container a').on('click', function (e) {
            e.preventDefault();
            $(this).tab('show');
        });
        $('#tabs_workflow .tabs_container a').on('click', function (e) {
            e.preventDefault();
            $(this).tab('show');
        });
        $('#tabs_workflow .tab-content a.next_icon_btn').on('click', function (e) {
            e.preventDefault();
            $('#tabs_workflow .tabs_container a' + $(this).attr('href')).trigger('click');
        });
        $('#tabs_workflow .tab-content a.prev_icon_btn').on('click', function (e) {
            e.preventDefault();
            $('#tabs_workflow .tabs_container a' + $(this).attr('href')).trigger('click');
        });
        $('.open-tab').on('click', function (e) {
            e.preventDefault();
            $('#tabs_workflow .tabs_container a' + $(this).attr('href')).trigger('click');
        });

        //Bootstrap Carousel
        $('.carousel-inner .carousel-item').first().addClass('active');

        // Select2 initializer
        $("select").select2();

        // removes the search from Select2 dropdown (Infinity or -1).
        $('select').select2({
            minimumResultsForSearch: Infinity
        });

    });   

    $(function () {
        var resizeEnd;
        $(window).on('resize', function () {
            clearTimeout(resizeEnd);
            resizeEnd = setTimeout(function () {
                $(window).trigger('resize-end');
            }, 250);
        });
    });

    //delay mobilePlacement until resize completes
    $(window).on('resize-end', function () {
        if ($("input").is(":focus")) {
            //prevent resize event on input focus to address Android keyboard bug
        } else {
            mobilePlacement();
        }
    });

    //Header form location + mobile menu item display + 3rd-tier flyout_left
    function mobilePlacement() {
        var contactForm = $(".contact_us_strip_container").detach();
        if ($(window).width() < 992) {
            contactForm.appendTo(".contact_us__mobile");
            $(".nav_item.submenu > a").addClass("nav_dropdown_parent");
            $(".nav_item.submenu_flyout > a").addClass("subnav_dropdown_parent");
        } else {
            contactForm.appendTo(".contact_us");
            $(".nav_item.submenu > a").removeClass("nav_dropdown_parent");
            $(".nav_item.submenu_flyout > a").removeClass("subnav_dropdown_parent");
            $("body").removeClass("mobile_nav"); 
        }

        if ($(window).width() > 991 && $(window).width() < 1501) {
            $(".nav_container > ul > .nav_item:gt(2)").addClass("flyout_left");
        }
        if ($(window).width() < 992 || $(window).width() > 1500) {
            $(".nav_container > ul > .nav_item:gt(2)").removeClass("flyout_left");
        }
    }
    
}(jQuery);
